import { action } from 'mobx';
import { FulfillmentUserService } from 'common/data';
import _ from 'lodash';

class FulfillmentUserStore {
	constructor(rootStore) {
		this.service = new FulfillmentUserService(rootStore.app.baasic.apiClient);
	}

	@action
	validateEmail = async email => {
		const response = await this.service.validateEmail(email);
		return response;
	};
}

export default FulfillmentUserStore;
